/** Canonical E.164 used to match Firebase Phone Auth tokens and team invites. */
export const toE164 = (value?: string | null): string | null => {
  const digits = (value ?? '').replace(/\D/g, '');
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  const trimmed = (value ?? '').trim();
  if (trimmed.startsWith('+') && digits.length >= 8) {
    return `+${digits}`;
  }
  return null;
};

export const nationalPhoneDigits = (value: string): string => {
  let digits = value.replace(/\D/g, '');
  if (digits.length >= 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
};

/** A US number as (208) 555-0100; anything else as given. */
export const displayPhone = (value: string): string => {
  const d = nationalPhoneDigits(value);
  return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : value;
};
